import React, { useState, useEffect, useMemo } from "react";
import Menu from "./templates/Menu"; // Usamos el Menu de Admin
import "./css/admin.css"; // Estilos de admin
import { MapContainer, TileLayer, Popup, useMapEvents, Marker } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import InterpolationLayer from "../ciudadano/InterpolationLayer"; // Reutilizamos componente ciudadano
import AirQualityExposure from "../ciudadano/AirQualityExposure"; // Reutilizamos componente ciudadano
import data from '../ciudadano/FeaturesFaq.json'; // Reutilizamos JSON
import { obtenerLecturas } from "../logicaFake/logicaFake";
import { 
    agregarMedidasCentro, 
    eliminarMedidasCentro, 
    agregarMedidasEstacion, 
    eliminarMedidasEstacion 
} from "../logicaFake/medidasVariadas";
import { renderToStaticMarkup } from 'react-dom/server';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SensorsIcon from '@mui/icons-material/Sensors';

const gandiaCenterLat = 38.96667;
const gandiaCenterLng = -0.18333;

const officialStations = [
    {
        id: 'estacion-gandia',
        nombre: 'Estación Gandía - Parc Alquería Nova',
        lat: 38.968129,
        lng: -0.193242,
        url: 'http://www.agroambient.gva.es/es/web/calidad-ambiental/datos-on-line'
    }
];

const officialStationIcon = L.divIcon({
    html: renderToStaticMarkup(
        <div style={{ 
            backgroundColor: 'white', 
            width: '40px', 
            height: '40px', 
            borderRadius: '8px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            border: '2px solid white', // Borde blanco igual que el fondo
            boxShadow: '0 4px 8px rgba(0,0,0,0.4)',
            zIndex: 1000
        }}>
            <AccountBalanceIcon style={{ 
                color: '#007bff', 
                fontSize: '24px'
            }} />
        </div>
    ),
    className: '', 
    iconSize: [40, 40],
    iconAnchor: [20, 20]
});

const StationPopup = ({ station }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Simular petición a API oficial
        const timer = setTimeout(() => {
            setData({
                so2: (Math.random() * 4 + 1).toFixed(1),      // 1-5
                no2: (Math.random() * 15 + 5).toFixed(1),     // 5-20
                o3: (Math.random() * 30 + 35).toFixed(1),     // 35-65
                co: (Math.random() * 0.3 + 0.1).toFixed(2),   // 0.1-0.4
                pm10: (Math.random() * 15 + 10).toFixed(1),   // 10-25
                pm25: (Math.random() * 8 + 3).toFixed(1),     // 3-11
                calidad: 'Buena',
                lastUpdate: new Date().toLocaleTimeString()
            });
            setLoading(false);
        }, 800); // Pequeño delay para realismo
        return () => clearTimeout(timer);
    }, []);

    if (loading) return <div style={{textAlign: 'center', padding: '10px'}}>🔄 Cargando datos oficiales...</div>;

    return (
        <div style={{minWidth: '200px'}}>
             <h5 style={{margin: '0 0 5px 0', fontSize: '1rem'}}>{station.nombre}</h5>
             <div style={{fontSize: '0.8rem', color: '#666', marginBottom: '8px'}}>Generalitat Valenciana • Red RVVCCA</div>
             
             <table className="table table-sm table-borderless" style={{fontSize: '0.9rem', marginBottom: '5px'}}>
                <tbody>
                    <tr>
                        <td style={{padding: '2px'}}><strong>SO₂</strong></td>
                        <td style={{padding: '2px', textAlign: 'right'}}>{data.so2} µg/m³</td>
                    </tr>
                    <tr>
                        <td style={{padding: '2px'}}><strong>NO₂</strong></td>
                        <td style={{padding: '2px', textAlign: 'right'}}>{data.no2} µg/m³</td>
                    </tr>
                    <tr>
                        <td style={{padding: '2px'}}><strong>O₃</strong></td>
                        <td style={{padding: '2px', textAlign: 'right'}}>{data.o3} µg/m³</td>
                    </tr>
                    <tr>
                        <td style={{padding: '2px'}}><strong>CO</strong></td>
                        <td style={{padding: '2px', textAlign: 'right'}}>{data.co} mg/m³</td>
                    </tr>
                    <tr>
                        <td style={{padding: '2px'}}><strong>PM10</strong></td>
                        <td style={{padding: '2px', textAlign: 'right'}}>{data.pm10} µg/m³</td>
                    </tr>
                    <tr>
                        <td style={{padding: '2px'}}><strong>PM2.5</strong></td>
                        <td style={{padding: '2px', textAlign: 'right'}}>{data.pm25} µg/m³</td>
                    </tr>
                </tbody>
             </table>
             
             <div style={{
                 backgroundColor: '#d1e7dd', 
                 color: '#0f5132', 
                 padding: '5px', 
                 borderRadius: '4px', 
                 textAlign: 'center',
                 fontWeight: 'bold',
                 marginBottom: '5px',
                 fontSize: '0.9rem'
             }}>
                 ICA: {data.calidad}
             </div>

             <div style={{fontSize: '0.75rem', color: '#999', textAlign: 'right', marginBottom: '5px'}}>
                 Actualizado: {data.lastUpdate}
             </div>

             <a href={station.url} target="_blank" rel="noopener noreferrer" style={{fontSize: '0.85rem', display: 'block', textAlign: 'center'}}>
                 Ver histórico web oficial ↗
             </a>
        </div>
    );
};

const colorScales = {
    'calidad': (medida) => {
        if (medida === 1) return 'green'; // Bueno
        if (medida === 2) return 'yellow'; // Aceptable
        return 'red'; // Malo
    },
    'co': (medida) => {
        if (medida <= 7) return 'green';
        if (medida <= 10) return 'yellow';
        return 'red';
    },
    'no2': (medida) => {
        if (medida <= 90) return 'green';
        if (medida <= 120) return 'yellow';
        return 'red';
    },
    'o3': (medida) => {
        if (medida <= 100) return 'green';
        if (medida <= 130) return 'yellow';
        return 'red';
    }
};

const sensorLimits = {
    'co': { low: 0, med: 7, high: 10 },
    'no2': { low: 0, med: 90, high: 120 },
    'o3': { low: 0, med: 100, high: 130 },
    'calidad': { low: 1, med: 2, high: 3 }
};

const getSeverityLevel = (tipoSensor, medida) => {
    const scale = colorScales[tipoSensor];
    if (!scale) return 0; // Sin severidad

    const color = scale(medida);
    if (color === 'green') return 1; // Bueno
    if (color === 'yellow') return 2; // Aceptable
    if (color === 'red') return 3; // Malo
    return 0;
};


const units = {
    'co': 'mg/m³',
    'no2': 'µg/m³',
    'o3': 'µg/m³',
    'calidad': ''
};


const DynamicSensorIcons = ({ lecturas }) => {
  const [zoomLevel, setZoomLevel] = useState(13);

  useMapEvents({
    zoomend: (e) => {
      setZoomLevel(e.target.getZoom());
    },
  });

  const getSize = (zoom) => {
    // Aumentamos ligeramente el tamaño base para que el contenedor se vea bien
    if (zoom < 12) return 20; 
    if (zoom < 14) return 25;
    if (zoom < 16) return 30;
    return 40;
  };

  const getColor = (medida, tipoSensor) => {
      if (colorScales[tipoSensor]) {
          return colorScales[tipoSensor](medida);
      }
      return 'gray';
  }

  const getDisplayUnit = (tipoSensor) => {
      return units[tipoSensor] || '';
  }

  const getDisplaySensorName = (tipoSensor) => {
      if (tipoSensor === 'co') return 'CO';
      if (tipoSensor === 'no2') return 'NO2';
      if (tipoSensor === 'o3') return 'O3';
      return tipoSensor.toUpperCase();
  }

  return (
    <>
      {lecturas.map((lectura, index) => {
        const size = getSize(zoomLevel);
        const bgColor = getColor(lectura.valor, lectura.tipo_sensor.toLowerCase());
        
        // Creamos un contenedor circular con el color de fondo
        const iconHtml = renderToStaticMarkup(
            <div style={{ 
                backgroundColor: bgColor, 
                width: size + 'px', 
                height: size + 'px', 
                borderRadius: '50%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                border: '2px solid rgba(255,255,255,0.8)', // Borde blanco suave para resaltar
                boxShadow: '0 2px 5px rgba(0,0,0,0.3)' // Sombra para dar profundidad
            }}>
                <SensorsIcon style={{ 
                    color: 'white', 
                    fontSize: (size * 0.7) + 'px' // El icono es un 70% del contenedor
                }} />
            </div>
        );

        const icon = L.divIcon({
            html: iconHtml,
            className: '', // Sin clase extra
            iconSize: [size, size],
            iconAnchor: [size / 2, size / 2]
        });

        return (
            <Marker
            key={`${lectura.id || 'no_id'}-${index}`}
            position={[lectura.latitud, lectura.longitud]}
            icon={icon}
            >
            <Popup>
                {getDisplaySensorName(lectura.tipo_sensor.toLowerCase())}: {lectura.valor.toFixed(2)} {getDisplayUnit(lectura.tipo_sensor.toLowerCase())} <br />
                Tiempo: {new Date(lectura.timestamp._seconds * 1000).toLocaleString()}
            </Popup>
            </Marker>
        );
      })}
    </>
  );
};


const legendData = {
    'calidad': {
        title: 'Calidad del Aire General',
        green: 'Buena / Razonable',
        yellow: 'Regular',
        red: 'Desfavorable / Mala',
    },
    'co': {
        title: 'Monóxido de Carbono (CO)',
        green: 'Buena (≤ 7 mg/m³)',
        yellow: 'Regular (7 - 10 mg/m³)',
        red: 'Mala (> 10 mg/m³)',
    },
    'no2': {
        title: 'Dióxido de Nitrógeno (NO2)',
        green: 'Buena (≤ 90 µg/m³)',
        yellow: 'Regular (90 - 120 µg/m³)',
        red: 'Mala (> 120 µg/m³)',
    },
    'o3': {
        title: 'Ozono (O3)',
        green: 'Buena (≤ 100 µg/m³)',
        yellow: 'Regular (100 - 130 µg/m³)',
        red: 'Mala (> 130 µg/m³)',
    }
};

const Legend = ({ sensor }) => {
    console.log("Sensor for legend: ", sensor);
    const data = legendData[sensor];
    if (!data) return null;

    return (
        <div className="info-legend">
            <h4>{data.title}</h4>
            <p><span style={{backgroundColor: 'rgba(0, 128, 0, 0.3)', width: '20px', height: '20px', display: 'inline-block', marginRight: '10px'}}></span>{data.green}</p>
            <p><span style={{backgroundColor: 'rgba(255, 255, 0, 0.3)', width: '20px', height: '20px', display: 'inline-block', marginRight: '10px'}}></span>{data.yellow}</p>
            <p><span style={{backgroundColor: 'rgba(255, 0, 0, 0.3)', width: '20px', height: '20px', display: 'inline-block', marginRight: '10px'}}></span>{data.red}</p>
        </div>
    );
};


function LecturasAdmin() {
  const [featureIndex, setFeatureIndex] = useState(0);
  const [mapView, setMapView] = useState('interpolation'); 
  const gandiaPosition = [38.96667, -0.18333];
  
  // --- ESTADO CON PERSISTENCIA (LOCALSTORAGE) ---
  const [selectedSensor, setSelectedSensor] = useState(() => localStorage.getItem('selectedSensor') || 'calidad');

  const hoy = new Date();
  const semanaPasada = new Date();
  semanaPasada.setDate(hoy.getDate() - 7);

  const [fechaInicio, setFechaInicio] = useState(() => localStorage.getItem('fechaInicio') || semanaPasada.toISOString().split('T')[0]);
  const [fechaFin, setFechaFin] = useState(() => localStorage.getItem('fechaFin') || hoy.toISOString().split('T')[0]);
  const [radio, setRadio] = useState(() => {
      const saved = localStorage.getItem('radio');
      return saved ? parseInt(saved, 10) : 5000;
  });

  // Lecturas cacheadas
  const [allLecturas, setAllLecturas] = useState(() => {
      const saved = localStorage.getItem('cachedLecturas');
      if (saved) {
          console.log("✅ Lecturas cargadas desde localStorage.");
          return JSON.parse(saved);
      }
      console.log("❌ No hay lecturas en localStorage, se realizará una consulta inicial a la API.");
      return [];
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Guardar configuración en localStorage al cambiar
  useEffect(() => {
    localStorage.setItem('fechaInicio', fechaInicio);
    localStorage.setItem('fechaFin', fechaFin);
    localStorage.setItem('radio', radio);
    localStorage.setItem('selectedSensor', selectedSensor);
  }, [fechaInicio, fechaFin, radio, selectedSensor]);


  // --- LÓGICA DE FILTRADO Y MAPA ---

  // Filtramos las lecturas que tenemos en memoria según el sensor seleccionado
  // Esto evita llamar a la API cuando cambiamos de pestaña
  const lecturasFiltradas = useMemo(() => {
      if (selectedSensor === 'calidad') return allLecturas;
      // Filtro en cliente
      return allLecturas.filter(l => l.tipo_sensor.toLowerCase() === selectedSensor.toLowerCase());
  }, [allLecturas, selectedSensor]);

  const airQualityPoints = useMemo(() => {
    if (selectedSensor !== 'calidad') return [];

    const pointsByLocation = {};

    allLecturas.forEach(lectura => {
        const key = `${lectura.latitud},${lectura.longitud}`;
        const severity = getSeverityLevel(lectura.tipo_sensor.toLowerCase(), lectura.valor);

        if (severity > (pointsByLocation[key]?.valor || 0)) {
            pointsByLocation[key] = {
                ...lectura,
                valor: severity, // Aquí 'valor' es el nivel de severidad
            };
        }
    });

    return Object.values(pointsByLocation);
  }, [allLecturas, selectedSensor]);

  const handleFiltrar = async () => {
    console.log("Botón 'Aplicar filtros' clickeado - Realizando consulta a la API.");
    setLoading(true);
    setError(null);
    
    let inicio = new Date(fechaInicio);
    let fin = new Date(fechaFin);
    inicio.setHours(0,0,0,0);
    fin.setHours(23,59,59,999);

    const opciones = {
        latitud: gandiaCenterLat,
        longitud: gandiaCenterLng,
        radio: radio,
        fechaInicio: inicio,
        fechaFin: fin,
        tiposensor: '' 
    };
    console.log("Opciones de filtrado (API):", opciones);
    try {
        let res = await obtenerLecturas(opciones);
        
        // --- LOGICA SMART FALLBACK (MAPA ADMIN) ---
        if (!res.error && res.length === 0) {
             const hoy = new Date();
             const esHoy = fin.getDate() === hoy.getDate() && fin.getMonth() === hoy.getMonth() && fin.getFullYear() === hoy.getFullYear();

             if (esHoy) {
                 console.log("🔄 Buscando historial reciente (Admin Mapa)...");
                 const hace30Dias = new Date(fin);
                 hace30Dias.setDate(hace30Dias.getDate() - 30);
                 
                 const opcionesHistorial = {
                     ...opciones,
                     fechaInicio: hace30Dias,
                     fechaFin: fin
                 };
                 
                 const resHistorial = await obtenerLecturas(opcionesHistorial);
                 
                 if (!resHistorial.error && resHistorial.length > 0) {
                     const lecturasOrdenadas = resHistorial.sort((a, b) => b.timestamp._seconds - a.timestamp._seconds);
                     const ultimaLectura = lecturasOrdenadas[0];
                     const ultimaFecha = new Date(ultimaLectura.timestamp._seconds * 1000);
                     
                     const nuevaFechaInicio = ultimaFecha.toISOString().split('T')[0];
                     
                     if (nuevaFechaInicio !== fechaInicio) {
                         setFechaInicio(nuevaFechaInicio);
                         
                         const inicioNuevo = new Date(nuevaFechaInicio); inicioNuevo.setHours(0,0,0,0);
                         res = resHistorial.filter(l => {
                             const t = new Date(l.timestamp._seconds * 1000);
                             return t >= inicioNuevo;
                         });
                     }
                 }
             }
        }

        console.log("Respuesta API:", res);
        if (res.error) {
            console.error("❌ Error al obtener lecturas:", res.error);
            setError(res.error);
            // No borramos allLecturas si hay error, mantenemos caché vieja o vacía
        } else {
            console.log("Lecturas actualizadas y guardadas en memoria.");
            setAllLecturas(res);
            localStorage.setItem('cachedLecturas', JSON.stringify(res));
        }
    } catch (err) {
        console.error("❌ Error inesperado:", err.message);
        setError(err.message);
    } finally {
        setLoading(false);
    }
  };

  // Carga inicial: Solo si no hay datos en caché
  useEffect(() => {
      if (allLecturas.length === 0) {
          handleFiltrar();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); 

  const handleSensorChange = (s) => {
    setSelectedSensor(s);
  };

  const toggleMapView = () => {
    setMapView(mapView === 'points' ? 'interpolation' : 'points');
  };
  
  const lecturasParaMapa = selectedSensor === 'calidad' ? airQualityPoints : lecturasFiltradas;


  return (
    <div className="home-page">
      <Menu />

      <main className="home-content">
        <h1 className="home-hero-title">MAPA DE CONTAMINANTES</h1>
        <div className="intranet-content-block">
        
        {/* Hero */}
        <section className="home-hero" style={{marginTop: '20px'}}>
          
          {/* NUEVA BARRA DE FILTROS HORIZONTAL (COPIADA DE CIUDADANO) */}
          <div className="filter-bar">
              {/* Grupo Sensor - Desplegable Compacto */}
              <div className="filter-group">
                  <span className="filter-label">Filtrar por:</span>
                  <select 
                    className="form-select form-select-sm" 
                    style={{ width: 'auto', fontWeight: '600', borderRadius: '8px' }}
                    value={selectedSensor}
                    onChange={(e) => handleSensorChange(e.target.value)}
                  >
                      <option value="calidad">Calidad General</option>
                      <option value="co">CO (Monóxido)</option>
                      <option value="no2">NO2 (Nitrógeno)</option>
                      <option value="o3">O3 (Ozono)</option>
                  </select>
              </div>

              {/* Grupo Fechas */}
              <div className="filter-group">
                  <input 
                    type="date" 
                    className="compact-date" 
                    value={fechaInicio} 
                    onChange={e => setFechaInicio(e.target.value)} 
                    title="Fecha Inicio"
                  />
                  <span style={{color: '#999'}}>—</span>
                  <input 
                    type="date" 
                    className="compact-date" 
                    value={fechaFin} 
                    onChange={e => setFechaFin(e.target.value)} 
                    title="Fecha Fin"
                  />
              </div>

              {/* Grupo Radio */}
              <div className="radius-control">
                  <span className="radius-label">Radio: {(radio / 1000).toFixed(1)} km</span>
                  <input 
                    type="range" 
                    className="compact-range" 
                    min="500" 
                    max="50000" 
                    step="500" 
                    value={radio} 
                    onChange={e => setRadio(parseInt(e.target.value, 10))} 
                  />
              </div>

              {/* Botones Acción */}
              <div className="action-group">
                   <button onClick={toggleMapView} className="btn-compact btn-toggle" title="Cambiar Vista Mapa">
                       {mapView === 'points' ? "🗺️ Mapa" : "📍 Puntos"}
                   </button>
                   <button onClick={handleFiltrar} className="btn-compact btn-apply">
                       Aplicar
                   </button>
              </div>
          </div>

            {error && <div className="alert alert-danger mt-3">{error}</div>}
          
          <MapContainer center={gandiaPosition} zoom={13} className="home-main-map">
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            {loading ? <p>Cargando...</p> : (
                mapView === 'points' ? (
                <DynamicSensorIcons lecturas={lecturasFiltradas} />
                ) : (
                <InterpolationLayer 
                    lecturas={lecturasParaMapa} 
                    colorScale={colorScales[selectedSensor]} 
                    isAirQualityView={selectedSensor === 'calidad'} 
                    sensorName={legendData[selectedSensor]?.title || selectedSensor}
                    unit={units[selectedSensor]}
                    limits={sensorLimits[selectedSensor]}
                />
                )
            )}
             {mapView === 'interpolation' && <Legend sensor={selectedSensor} />}
             
             {/* Estaciones Oficiales */}
             {officialStations.map(station => (
                 <Marker 
                    key={station.id} 
                    position={[station.lat, station.lng]} 
                    icon={officialStationIcon}
                    zIndexOffset={1000} // Prioridad visual alta
                 >
                     <Popup>
                         <StationPopup station={station} />
                     </Popup>
                 </Marker>
             ))}

          </MapContainer>

          <AirQualityExposure startDate={fechaInicio} endDate={fechaFin} readings={allLecturas} />

          <div className="mt-3 text-center">
            <button 
                className="btn btn-secondary" 
                onClick={async () => {
                    const confirm = window.confirm("¿Ejecutar script de 20 nodos? Esto añadirá datos de prueba.");
                    if (!confirm) return;

                    console.log("🚀 Iniciando prueba de 20 nodos...");
                    const BASE_URL = "https://us-central1-proyectodebiometria.cloudfunctions.net/ServidorREST";
                    const PROPIETARIO_ID = "mcJtObhq2iOpCnm6AT6xbFB8zYT2";
                    const CENTER_LAT = 39.00500;
                    const CENTER_LNG = -0.16500;
                    const NUM_NODOS = 20;
                    const DISTANCIA_ENTRE_PUNTOS_KM = 0.25;
                    const perimetroTotal = NUM_NODOS * DISTANCIA_ENTRE_PUNTOS_KM;
                    const radiusKm = perimetroTotal / (2 * Math.PI);
                    const DEG_PER_KM = 0.009;
                    const RADIUS_DEG = radiusKm * DEG_PER_KM;

                    for (let i = 1; i <= NUM_NODOS; i++) {
                        const nodoId = `nodo_${i}`;
                        const angle = ((i - 1) / NUM_NODOS) * 2 * Math.PI;
                        const lat = CENTER_LAT + RADIUS_DEG * Math.cos(angle);
                        const lng = CENTER_LNG + RADIUS_DEG * Math.sin(angle);

                        let valorCO;
                        if (i <= 7) valorCO = 12 + Math.random() * 3;
                        else if (i <= 13) valorCO = 7.5 + Math.random() * 2;
                        else valorCO = 11 + Math.random() * 3;
                        
                        valorCO = parseFloat(valorCO.toFixed(2));

                        // Crear Nodo
                        try {
                            await fetch(`${BASE_URL}/nodos`, {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({ nombre: nodoId, propietarioId: PROPIETARIO_ID }),
                            });
                        } catch (e) { console.error("Error creando nodo", e); }

                        // Enviar Lectura 1
                        try {
                            await fetch(`${BASE_URL}/lecturas`, {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({
                                    nombreNodo: nodoId,
                                    propietarioId: PROPIETARIO_ID,
                                    lecturas: [{ tipo: 'CO', valor: valorCO }],
                                    latitud: lat,
                                    longitud: lng,
                                }),
                            });
                        } catch (e) { console.error("Error enviando lectura 1", e); }

                        // Enviar Lectura 2
                        try {
                            await fetch(`${BASE_URL}/lecturas`, {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({
                                    nombreNodo: nodoId,
                                    propietarioId: PROPIETARIO_ID,
                                    lecturas: [{ tipo: 'CO', valor: valorCO + (Math.random() * 1 - 0.5) }],
                                    latitud: lat + 0.0001,
                                    longitud: lng + 0.0001,
                                }),
                            });
                        } catch (e) { console.error("Error enviando lectura 2", e); }

                        console.log(`Nodo ${nodoId} procesado.`);
                    }
                    alert("✅ Prueba de 20 nodos finalizada. Recargando mapa...");
                    handleFiltrar();
                }}
            >
                🧪 Prueba 20 Nodos
            </button>
            <button 
                className="btn btn-danger ms-2" 
                onClick={async () => {
                    const confirm = window.confirm("¿Estás seguro de que quieres eliminar los 20 nodos de prueba y sus lecturas? Esta acción no se puede deshacer.");
                    if (!confirm) return;

                    console.log("🚀 Eliminando 20 nodos de prueba...");
                    const BASE_URL = "https://us-central1-proyectodebiometria.cloudfunctions.net/ServidorREST";
                    const NUM_NODOS = 20;

                    for (let i = 1; i <= NUM_NODOS; i++) {
                        const nodoId = `nodo_${i}`;
                        
                        // Eliminar Nodo (enviando nombre y propietario en el body)
                        try {
                            const response = await fetch(`${BASE_URL}/nodos`, {
                                method: "DELETE",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({ 
                                    nombreNodo: nodoId, 
                                    propietarioId: "mcJtObhq2iOpCnm6AT6xbFB8zYT2" 
                                }),
                            });
                            
                            if (response.ok) {
                                console.log(`Nodo ${nodoId} eliminado.`);
                            } else {
                                console.error(`Error eliminando nodo ${nodoId}: ${response.statusText}`);
                            }

                        } catch (e) { console.error(`Excepción eliminando nodo ${nodoId}`, e); }
                    }
                    alert("🗑️ Nodos eliminados.");
                    handleFiltrar();
                }}
            >
                🗑️ Eliminar 20 Nodos
            </button>
            <button 
                className="btn btn-info ms-2" 
                onClick={async () => {
                    const confirm = window.confirm("¿Crear 20 lecturas en forma de cuadrado (Nodo 0)?");
                    if (!confirm) return;

                    console.log("🚀 Iniciando prueba cuadrado (Nodo 0)...");
                    const BASE_URL = "https://us-central1-proyectodebiometria.cloudfunctions.net/ServidorREST";
                    const PROPIETARIO_ID = "mcJtObhq2iOpCnm6AT6xbFB8zYT2";
                    const NODO_ID = "nodo0";
                    
                    // Coordenadas Gandía Playa
                    const START_LAT = 39.006;
                    const START_LNG = -0.165;
                    const STEP = 0.001; // ~100 metros

                    // Crear Nodo 0
                    try {
                        await fetch(`${BASE_URL}/nodos`, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ nombre: NODO_ID, propietarioId: PROPIETARIO_ID }),
                        });
                    } catch (e) { console.error("Error creando nodo 0", e); }

                    // 5x4 Grid = 20 puntos
                    let count = 0;
                    for (let latIdx = 0; latIdx < 5; latIdx++) {
                        for (let lngIdx = 0; lngIdx < 4; lngIdx++) {
                            const lat = START_LAT + (latIdx * STEP);
                            const lng = START_LNG + (lngIdx * STEP);
                            
                            // Valor aleatorio
                            const valorCO = parseFloat((Math.random() * 12).toFixed(2)); 

                            try {
                                await fetch(`${BASE_URL}/lecturas`, {
                                    method: "POST",
                                    headers: { "Content-Type": "application/json" },
                                    body: JSON.stringify({
                                        nombreNodo: NODO_ID,
                                        propietarioId: PROPIETARIO_ID,
                                        lecturas: [{ tipo: 'CO', valor: valorCO }],
                                        latitud: lat,
                                        longitud: lng,
                                    }),
                                });
                                count++;
                                console.log(`Lectura ${count}/20 enviada para ${NODO_ID}`);
                            } catch (e) { console.error("Error enviando lectura", e); }
                        }
                    }
                    alert("✅ Prueba Cuadrado (20 lecturas) finalizada. Recargando mapa...");
                    handleFiltrar();
                }}
            >
                🟦 Cuadrado (Nodo 0)
            </button>
            <button 
                className="btn btn-warning ms-2" 
                onClick={async () => {
                    const confirm = window.confirm("¿Eliminar Nodo 0 y sus lecturas?");
                    if (!confirm) return;

                    console.log("🚀 Eliminando Nodo 0...");
                    const BASE_URL = "https://us-central1-proyectodebiometria.cloudfunctions.net/ServidorREST";
                    const NODO_ID = "nodo0";
                    const PROPIETARIO_ID = "mcJtObhq2iOpCnm6AT6xbFB8zYT2";

                    try {
                        const response = await fetch(`${BASE_URL}/nodos`, {
                            method: "DELETE",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ 
                                nombreNodo: NODO_ID, 
                                propietarioId: PROPIETARIO_ID 
                            }),
                        });
                        
                        if (response.ok) {
                            console.log(`Nodo ${NODO_ID} eliminado.`);
                            alert(`🗑️ Nodo ${NODO_ID} eliminado correctamente.`);
                        } else {
                            console.error(`Error eliminando nodo ${NODO_ID}: ${response.statusText}`);
                            alert(`❌ Error al eliminar Nodo ${NODO_ID}.`);
                        }

                    } catch (e) { 
                        console.error(`Excepción eliminando nodo ${NODO_ID}`, e);
                        alert(`❌ Excepción al eliminar Nodo ${NODO_ID}.`);
                    }
                    handleFiltrar();
                }}
            >
                🗑️ Eliminar Nodo 0
            </button>
            <button
                className="btn btn-success ms-2"
                onClick={async () => {
                    const confirm = window.confirm("¿Añadir 60 lecturas variadas en Centro Gandía?");
                    if (!confirm) return;
                    await agregarMedidasCentro();
                    alert("✅ 60 lecturas variadas (Centro) añadidas.");
                    handleFiltrar();
                }}
            >
                🏙️ Centro Añadir
            </button>
            <button
                className="btn btn-danger ms-2"
                onClick={async () => {
                    const confirm = window.confirm("¿Eliminar lecturas variadas del Centro?");
                    if (!confirm) return;
                    try {
                        await eliminarMedidasCentro();
                        alert("🗑️ Lecturas Centro eliminadas.");
                    } catch (e) {
                        alert("❌ Error eliminando lecturas Centro.");
                    }
                    handleFiltrar();
                }}
            >
                🗑️ Centro Eliminar
            </button>

            <button
                className="btn btn-info ms-2"
                style={{color: 'white'}}
                onClick={async () => {
                    const confirm = window.confirm("¿Añadir 20 lecturas cerca de Estación Oficial?");
                    if (!confirm) return;
                    await agregarMedidasEstacion();
                    alert("🏭 20 lecturas (Estación) añadidas.");
                    handleFiltrar();
                }}
            >
                🏭 Estación Añadir
            </button>
            <button
                className="btn btn-dark ms-2"
                onClick={async () => {
                    const confirm = window.confirm("¿Eliminar lecturas de Estación?");
                    if (!confirm) return;
                    try {
                        await eliminarMedidasEstacion();
                        alert("🗑️ Lecturas Estación eliminadas.");
                    } catch (e) {
                        alert("❌ Error eliminando lecturas Estación.");
                    }
                    handleFiltrar();
                }}
            >
                🗑️ Estación Eliminar
            </button>
          </div>
        </section>
        </div>
      </main>
    </div>
  );
}

export default LecturasAdmin;